<script lang="ts">
	import { onMount, onDestroy } from 'svelte';
	import { browser } from '$app/environment';
	import ChevronUp from './ChevronUp.svelte';

	let visible = false;
	let enabled = false;

	function updateVisibility() {
		if (!browser) return;
		visible = window.scrollY > 100;
	}

	function scrollToTop() {
		if (!browser) return;
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	onMount(() => {
		if (!browser) return;
		if (document.documentElement.scrollHeight > window.innerHeight) {
			enabled = true;
			updateVisibility();
			window.addEventListener('scroll', updateVisibility);
		}
	});

	onDestroy(() => {
		if (browser) {
			window.removeEventListener('scroll', updateVisibility);
		}
	});
</script>

{#if enabled}
	<button
		class="scroll-to-top"
		class:show={visible}
		on:click={scrollToTop}
		aria-label="Scroll to top"
	>
		<div class="icon-wrapper">
			<ChevronUp />
		</div>
	</button>
{/if}

<style>
	.scroll-to-top {
		position: fixed;
		bottom: 1.5rem;
		right: 1.5rem;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: var(--brand-primary);
		border: 2px solid white;
		box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
		cursor: pointer;
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.3s ease, border-color 0.2s ease;
		z-index: 1000;
	}

	.scroll-to-top:hover {
		border-color: var(--brand-secondary);
		filter: drop-shadow(0px 0px 3px var(--brand-secondary));
		transition: all 0.2s ease-in-out;
	}

	.scroll-to-top:hover .icon-wrapper {
		filter: drop-shadow(0px 0px 3px var(--brand-secondary));
		transition: all 0.2s ease-in-out;
	}

	.icon-wrapper {
		width: 24px;
		height: 24px;
		color: white;
		filter: brightness(0) invert(1);
		transition: all 0.2s ease-in-out;
	}

	.scroll-to-top.show {
		opacity: 1;
		pointer-events: auto;
	}

	/* Responsive positioning */
	@media (min-width: 768px) {
		.scroll-to-top {
			right: 2rem;
		}
	}

	@media (min-width: 1024px) {
		.scroll-to-top {
			right: 2rem;
		}
	}

	@media (min-width: 1200px) {
		.scroll-to-top {
			right: calc((100vw - 1080px) / 2 + 30px);
		}
	}
</style>
